const STORAGE_KEY = 'LiveWeightDisplay';
export const LIVE_WEIGHT_DISPLAY_EVENT = 'genweb:liveWeightDisplay';

/**
 * @returns {boolean}
 */
export function readLiveWeightDisplayPreference() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * @param {boolean} enabled
 */
export function writeLiveWeightDisplayPreference(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore quota / private mode
  }
  try {
    window.dispatchEvent(new CustomEvent(LIVE_WEIGHT_DISPLAY_EVENT, { detail: { enabled: Boolean(enabled) } }));
  } catch {
    // ignore
  }
}
